import request from '@/utils/request';
const baseUrl = process.env.VUE_APP_API_RULE;
const BASE_Mul_URL = process.env.VUE_APP_GIAM_BASE;
const isProd = process.env.NODE_ENV === 'production';
import qs from 'qs';

// 自动规则-创建规则
export function rulesCreate(data) {
  return request({
    baseURL: baseUrl,
    url: '/alert/rules/create',
    method: 'post',
    data,
    withCredentials: isProd,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
// 自动规则-列表
export function rules(params) {
  let ret = '';
  for (let it in params) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(params[it]) + '&';
  }

  return request({
    baseURL: baseUrl,
    url: '/alert/rules?' + ret,
    withCredentials: isProd,
    method: 'get',
    timeout: 30000,
  });
}
//规则详情
export function rulesDetail(params) {
  return request({
    baseURL: baseUrl,
    url: '/alert/rules/detail',
    withCredentials: isProd,
    method: 'get',
    params,
  });
}
// 自动规则-修改规则
export function rulesUpdate(data) {
  return request({
    baseURL: baseUrl,
    url: '/alert/rules/update',
    method: 'post',
    withCredentials: isProd,
    data,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
// 自动规则-删除规则
export function rulesDelete(data) {
  return request({
    baseURL: baseUrl,
    url: `/alert/rules/delete?rule_id=${data}`,
    method: 'post',
    withCredentials: isProd,
    transformRequest: [
      function (data) {
        return qs.stringify(data);
      },
    ],
  });
}
// 自动规则-创建执行
export function rulesRun(data) {
  return request({
    baseURL: baseUrl,
    url: `/alert/rules/run?rule_id=${data}`,
    method: 'post',
    withCredentials: isProd,
    headers: { 'Content-Type': 'form-data' },
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
//自动规则修改状态
export function updateStatus(data) {
  let ret = '';
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
  }
  return request({
    baseURL: baseUrl,
    withCredentials: isProd,
    url: '/alert/rules/updateStatus?' + ret,
    method: 'post',
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
// 自动规则-执行-列表
export function runList(params) {
  return request({
    baseURL: baseUrl,
    withCredentials: isProd,
    url: '/alert/rules/run/list',
    method: 'get',
    params,
  });
}
//自动规则-模板列表
export function rulesTemplate(params) {
  return request({
    baseURL: baseUrl,
    withCredentials: isProd,
    url: '/alert/rules/template',
    method: 'get',
    params,
  });
}
// 自动规则-团队列表
export function gimpAreaList() {
  return request({
    baseURL: baseUrl,
    withCredentials: isProd,
    url: '/gimp/areaList',
    method: 'get',
  });
}
// 自动规则-国家列表
export function gimpCountryList() {
  return request({
    baseURL: baseUrl,
    withCredentials: isProd,
    url: '/gimp/countryList',
    method: 'get',
  });
}
// 自动规则-币种列表
export function gimpCurrencyList() {
  return request({
    baseURL: baseUrl,
    withCredentials: isProd,
    url: '/gimp/currencyList',
    method: 'get',
  });
}
//历史预警消息
export function messages(params) {
  return request({
    baseURL: baseUrl,
    withCredentials: isProd,
    url: '/alert/messages',
    method: 'get',
    params,
  });
}
//历史预警消息统计
export function messagesSummary(params) {
  return request({
    baseURL: baseUrl,
    withCredentials: isProd,
    url: '/alert/messages/summary',
    method: 'get',
    params,
  });
}
// 自动规则-指派
export function appoint(params) {
  return request({
    baseURL: baseUrl,
    withCredentials: isProd,
    url: '/alert/rules/appoint',
    method: 'get',
    params,
  });
}
export function getCampaignList(params) {
  return request({
    baseURL: BASE_Mul_URL,
    url: '/saleCampaign/getCampaignList',
    method: 'get',
    params,
  });
}

// 自动规则-存为模板
export function templateSave(data) {
  return request({
    baseURL: baseUrl,
    url: '/alert/rules/template/save',
    method: 'post',
    data,
    withCredentials: isProd,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}

// 自动规则-删除模板
export function templateDelete(params) {
  return request({
    baseURL: baseUrl,
    params,
    url: `/alert/rules/template/delete`,
    method: 'get',
    withCredentials: isProd,
  });
}

// 自动规则-近7天执行次数
export function rulesRunCount(data) {
  return request({
    baseURL: baseUrl,
    url: '/alert/rules/executeCount',
    method: 'post',
    data,
    withCredentials: true,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
